import React from 'react';
import { Button, Dropdown } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { PZBatchConversionTarget } from '../pzBatchQuantityConversion';

interface Props {
  onConvert: (target: PZBatchConversionTarget) => void;
  disabled?: boolean;
}

const PZBatchConversionMenu: React.FC<Props> = ({ onConvert, disabled = false }) => {
  const { t } = useTranslation(['pz']);

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          { key: 'pcs', label: t('pz:batchConversion.toPcs') },
          { key: 'm2', label: t('pz:batchConversion.toM2') },
          { key: 'm3', label: t('pz:batchConversion.toM3') },
        ],
        onClick: ({ key }) => onConvert(key as PZBatchConversionTarget),
      }}
    >
      <Button icon={<CalculatorOutlined />} disabled={disabled}>
        {t('pz:batchConversion.action')}
      </Button>
    </Dropdown>
  );
};

export default PZBatchConversionMenu;
